import { GlobalDataService } from '@providers/global-data/global-data.service';
import * as i0 from "@angular/core";
import * as i1 from "../global-data/global-data.service";
var ModelsToolsService = /** @class */ (function () {
    function ModelsToolsService(globalDataService) {
        this.globalDataService = globalDataService;
    }
    ModelsToolsService.prototype.isStepValid = function (id, mode) {
        if (mode === void 0) { mode = 'id'; }
        // Select step category
        var categoryRange = this.globalDataService.stepsCategory
            .filter(function (i) { return i.name === 'Études' || i.name === 'S.A.V' || i.name === 'Travaux'; })
            .map(function (i) { return i.id; });
        var stepsRange = this.globalDataService.steps
            .filter(function (i) { return categoryRange.includes(i.id_step_category); });
        var found = stepsRange
            .find(function (i) { return i[mode] === id; });
        return !!found;
    };
    ModelsToolsService.prototype.isDesignStep = function (id, mode) {
        if (mode === void 0) { mode = 'id'; }
        // Select step category
        var designCategory = this.globalDataService.stepsCategory.find(function (i) { return i.name === 'Études'; });
        var found = this.globalDataService.steps.find(function (i) { return i[mode] === id; });
        if (found) {
            return designCategory.id === found.id_step_category;
        }
        return false;
    };
    ModelsToolsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ModelsToolsService_Factory() { return new ModelsToolsService(i0.ɵɵinject(i1.GlobalDataService)); }, token: ModelsToolsService, providedIn: "root" });
    return ModelsToolsService;
}());
export { ModelsToolsService };
